import React from 'react'
import { useNavigate } from 'react-router-dom'
import VisibilityIcon from '@mui/icons-material/Visibility'
import Tooltip from 'components/generic/tooltip'
import getButtonCell from 'components/generic/datagrid/cells/ButtonCell'
import { formatNumber } from 'utils/helpers'
import { dateUnixFormatter } from 'utils/data-manipulation/valueFormatter'
import DataGridWithSearch from './DataGridWithSearch'

const makeMaterialToolTip = materials => (
  <Tooltip content={materials}>
    <>{materials.length > 1 ? 'Mixed' : materials}</>
  </Tooltip>
)

const getColumns = navigate => [
  {
    field: 'miniId',
    headerName: 'Packing List #',
    flex: 1,
  },
  {
    field: 'createdDate',
    headerName: 'Date',
    flex: 1,
    renderCell: params => {
      const { createdDate } = params?.row || {}
      if (!createdDate || Number.isNaN(new Date(createdDate).getTime())) return '--'
      return createdDate
    },
    // This method ensures that sorting will work correctly regardless of the date format displayed to the user.
    sortComparator: (param1, param2) => {
      const timestamp1 = dateUnixFormatter(param1)
      const timestamp2 = dateUnixFormatter(param2)

      return timestamp1 - timestamp2
    },
  },
  {
    field: 'material',
    headerName: 'Material',
    flex: 1,
    renderCell: params => makeMaterialToolTip(params.row.materials),
  },
  {
    field: 'netWeight',
    headerName: 'Net Weight',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => formatNumber(`${params?.row?.netWeight}`),
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
  },
  {
    field: 'view',
    headerName: 'Actions',
    type: 'actions',
    width: 150,
    renderCell: params => getButtonCell(params, 'View', <VisibilityIcon />, () => navigate(params.row.id)),
  },
]

const PackingListsGrid = props => {
  const navigate = useNavigate()
  return <DataGridWithSearch {...props} columns={getColumns(navigate)} />
}

PackingListsGrid.propTypes = DataGridWithSearch.propTypes

PackingListsGrid.defaultProps = DataGridWithSearch.defaultProps

export default PackingListsGrid
